import dayjs from 'dayjs';
import {iTimedMsgDateRange} from './TimedMessageRequest';

export const isValidTimedMsgDates = (
  dates: iTimedMsgDateRange[],
  dayType: string,
  isStaff: boolean,
) => {
  const today = isStaff
    ? dayjs().subtract(1, 'day').startOf('day')
    : dayjs().startOf('day');

  if (dates.length === 0) {
    return false;
  }
  if (dayType === 'multiple' && dates.length > 10) {
    // On Timed message update, disable the "NEXT" button when dateRanges exceed 10
    return false;
  }
  const dateRanges = dates.filter(o => o.id < 0);
  if (dateRanges.some(o => o.chosenDays && o.chosenDays.length === 0)) {
    return false;
  }
  return dateRanges.every(dateRange => {
    const startDate = dayjs(dateRange.start_date).startOf('day');
    const endDate = dayjs(dateRange.end_date).startOf('day');
    let isPastDate =
      dayType !== 'multiple'
        ? startDate.isAfter(today)
        : startDate.isAfter(today) && endDate.isAfter(today);
    let dateCheck =
      dateRange.start_date && (dayType !== 'multiple' || dateRange.end_date);
    return dateCheck && isPastDate;
  });
};
